import Starry from './top/starry/starry.es6';
import ScrollFunc from './top/scrollfunc.es6';
import ShuffleTxt from './top/shuffletxt.es6';
import Slider from './top/slider.es6';
import Modal from './top/modal.es6';
import Acc from './top/acc.es6';
import Tab from './top/tab.es6';

class Main {
    constructor() {
        this.starry = new Starry();
        this.scrollFunc = new ScrollFunc();
        this.shuffleTxt = new ShuffleTxt();
        this.slider = new Slider();
        this.modal = new Modal();
        this.acc = new Acc();
        this.tab = new Tab(this);

        this._init();
    }

    _init() {
        this._eventBind();
    }

    _eventBind() {
        window.addEventListener('load', () => {
            document.body.classList.add('-ready');

            setTimeout(() => {
                this.scrollFunc.setObserve();
                this.shuffleTxt.setObserve();
                this.slider.initSlider();
                this.acc.eventBind();
                this.tab.eventBind();
            }, 1500);
        });
    }
}

const main = new Main();
